import type React from 'react';

import { permissionManager } from '@/utils/permission';

interface Props {
    perm: string[];
    children: React.ReactNode;
}

export const PermissionGuard: React.FC<Props> = ({ perm, children }) => {
    const hasPerm = permissionManager.hasUserPermission(perm);

    if (!hasPerm) return null;

    return children;
};
